import React, { useEffect, useState } from 'react'
import { BASE_URL } from '../../config/axios';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import EmployeeDetailCard from './EmployeeDetailCard';
import { customSortByKey } from '../CustomFunctions';
import { Active, CircularGrid, Filter, Office, Refresh, Search, SearchBig } from '../AllSvg';
import { AddNewEmployeeData } from './components/AddNewEmployeeModel';
import usePermission from '../../config/permissions';
import { normalizeEmployeeStatus } from '../CustomFunctions';

const EmployeeDetails = () => {
  const { SUPER_ADMIN, SUB_COMPANIES, PORTAL_SETTINGS } = usePermission();

  const [buffer, setBuffering] = useState(false); //buffering logic

  // *********** Employee Details Api Start ***********
  const [allemployee, setAllemployee] = useState([])
  const [filteredEmployee, setFilteredEmployee] = useState([]);
  const [selectedDivision, setDivision] = useState(`${sessionStorage.getItem('company_id')}`);

  const getAllEmployee = async () => {
    setBuffering(true); //buffering logic
    try {
      const res = await axios.get(`${BASE_URL}/wfm/ourcompanyuserlessdetail/v3/${selectedDivision}/null/`);
      const sortedData = customSortByKey(res.data, "emp_code");

      const normalizedEmployees = sortedData.map((employee) => ({
        ...employee,
        employee_status: normalizeEmployeeStatus(employee.employee_status),
      }));
      setAllemployee(normalizedEmployees)
    } catch (err) {
      // alert(err.message);
    } finally {
      setBuffering(false); //buffering logic
    }
  };


  useEffect(() => {
    getAllEmployee();
  }, [selectedDivision]);
  // *********** Employee Details Api End ***********

  const refreshdata = async () => {
    setBuffering(true); //buffering logic
    await getAllEmployee();
    setBuffering(false); //buffering logic
  };


  // *********** Filter Logic ***********


  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([])
  const [rhList, setRhList] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedName, setName] = useState('');


  const getDepartmentAndDesignation = async () => {
    try {
      const dep = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${selectedDivision}/active/`);
      const des = await axios.get(`${BASE_URL}/wfm/designationfilterbysubcompanycount/${selectedDivision}/active/`);
      setDepartmentList(dep.data)
      setDesignationList(des.data)
    } catch (err) {
      // alert(err.message);
    }
  };

  const getRhlist = async () => {
    try {
      // const res = await axios.get(`${BASE_URL}/wfm/rhlist/`);
      const res = await axios.get(`${BASE_URL}/wfm/rhlistactive/${selectedDivision}/active/`);
      setRhList(res.data);
    } catch (err) {
      // alert(err.message);
    }
  };

  useEffect(() => {
    getRhlist();
    getDepartmentAndDesignation();
  }, [selectedDivision]);

  const [selectedDep, setDep] = useState('');
  const [selectedDesi, setDesi] = useState('');
  const [selectedRH, setRh] = useState('');
  const [selectedRole, setRole] = useState('');

  const applyFilters = () => {
    let filteredData = allemployee;

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();
      filteredData = filteredData.filter(employee => {
        const nameMatch = employee.name.toLowerCase().includes(lowercaseSelectedName);
        const empCodeMatch = employee.emp_code.toString().includes(selectedName);
        return nameMatch || empCodeMatch;
      });
    }

    // if (selectedStatus !== '') {
    //   filteredData = filteredData.filter(employee => employee.employee_status === selectedStatus);
    // }
    if (selectedStatus !== '') {
      filteredData = filteredData.filter(employee => normalizeEmployeeStatus(employee.employee_status) === selectedStatus);
    }

    if (selectedDep) {
      filteredData = filteredData.filter(employee => employee.department_name === selectedDep);
    }

    if (selectedDesi) {
      const lowercaseSelectedName = selectedDesi.toLowerCase();

      filteredData = filteredData.filter(employee => {
        const desiMatch = employee.designation_name.toLowerCase().includes(lowercaseSelectedName);
        return desiMatch;
      });
    }

    if (selectedRH) {
      filteredData = filteredData.filter(employee => employee.rh_name === selectedRH);
    }

    if (selectedRole) {
      filteredData = filteredData.filter(employee => employee.role === selectedRole);
    }

    setFilteredEmployee(filteredData);
  };

  useEffect(() => {

    applyFilters();
  }, [selectedStatus, selectedName, allemployee, selectedDep, selectedDesi, selectedRH, selectedRole]);

  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");

  const navigate = useNavigate()
  const Viewdetails = (emp_code, user_detail) => {
    navigate(`/${urlParts[3]}/userdetailscrud/${emp_code}/${user_detail}/`)
  }

  return (
    <div>
      <div>
        <div className="attendance-subcont">
          <div className="field-cont">

            {SUPER_ADMIN && <div className="field-cont-div">
              <Office />
              <select className="attendance-input-field width-10vw   date-field" type="text"
                value={selectedDivision}
                onChange={(e) => { setDivision(e.target.value); }}
              >
                <option value=""> All Sub Companies</option>
                {SUB_COMPANIES.sort((a, b) => a.title - b.title).map((i, index) => (<option value={i.id}>{i.title}</option>))};

              </select>
              <hr className="field-cont-hr" />
            </div>}

            <div className="field-cont-div">
              <Active />
              <select className="attendance-input-field  date-field" type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="">All</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <SearchBig />
              <input className="attendance-input-field width-10vw  " placeholder='Name or Code' type="text" value={selectedName}
                onChange={(e) => setName(e.target.value)} />

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <CircularGrid />
              <select className="attendance-input-field width-15vw   date-field" type="text"
                value={selectedDep}
                onChange={(e) => setDep(e.target.value)}
              >
                <option value=""> All Department</option>
                {departmentList.sort((a, b) => a.title - b.title).map((i, index) => (<option value={i.title}>{i.title}</option>))};
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <SearchBig />
              <input className="attendance-input-field width-15vw  " placeholder='Designation' type="text" value={selectedDesi}
                onChange={(e) => setDesi(e.target.value)} />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Filter />
              <select className="attendance-input-field width-15vw" type="text"
                value={selectedRH}
                onChange={(e) => setRh(e.target.value)}
              >
                <option value=""> All Reporting Heads</option>
                {rhList.sort((a, b) => a.name - b.name).map((i, index) => (<option value={i.name}>{i.name}</option>))};
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Filter />
              <select className="attendance-input-field width-10vw" type="text"
                value={selectedRole}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value="">All Roles</option>
                <option value="Employee">Employee</option>
                <option value="ReportingHead">Team Lead</option>
                <option value="HOD">HOD</option>
                <option value="Career">Career</option>
                <option value="HR">HR</option>
                <option value="Admin">Admin</option>
                <option value="IT">IT</option>
                <option value="Account">Accounts</option>
                {/* <option value="SiteManagement">Site Management</option> */}
              </select>
              <hr className="field-cont-hr" />
            </div>

          </div>

          <div className="btn-cont">
            {PORTAL_SETTINGS?.direct_emp_creation &&
              <AddNewEmployeeData
                getAllEmployee={getAllEmployee}
                SubCompany={SUB_COMPANIES}
                SUPER_ADMIN={SUPER_ADMIN}
              />
            }
          </div>
        </div>
      </div>
      <div className='filter-showing'>
        <div>Showing  {filteredEmployee.length} of {allemployee.length} </div>
        <div>
          {buffer ?
            <div className="spinner-vsmall"></div>
            :
            <div
              className="refresh-button"
              onClick={refreshdata}
              disabled={buffer} //buffering logic
            >
              <Refresh />
            </div>
          }
        </div>
      </div>

      {
        buffer ? <div className="spinner"></div> :
          <EmployeeDetailCard
            getAllEmployee={getAllEmployee}
            filteredEmployee={filteredEmployee}
            Viewdetails={Viewdetails}
            SubCompany={SUB_COMPANIES}
            SUPER_ADMIN={SUPER_ADMIN}
          />}

    </div>
  )
}

export default EmployeeDetails
